import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _hoisted_1 = { class: "brand_culture_desire_content" }
const _hoisted_2 = {
  class: "brand_culture_desire_title",
  "data-aos": "fade-down"
}
const _hoisted_3 = { class: "brand_culture_desire_boxs" }
const _hoisted_4 = ["data-aos-delay"]
const _hoisted_5 = { class: "brand_culture_desire_box_title" }
const _hoisted_6 = { class: "brand_culture_desire_box_bg" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "brand_culture_desire_box_des_icon",
  src: _imports_0
}, null, -1)
const _hoisted_9 = { class: "brand_culture_desire_box_content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.info.title) + " ", 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.list, (desire, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "brand_culture_desire_box",
            key: index,
            "data-aos": "fade-up",
            "data-aos-delay": index * 200
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(desire.title), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                class: "brand_culture_desire_box_icon",
                src: desire.img
              }, null, 8, _hoisted_7),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(desire.content), 1)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}